import GeneralFilter from '../../../../Model/GeneralFilter'

export default class SystemTransactionFilter extends GeneralFilter {
  constructor () {
    super()
    this.setInitialValue()
  }

  setInitialValue () {
    this.setFilterInitialValue()
  }
}
